import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import Chat from "../../../components/Chat";

function AdminCustomerSupport() {
  return (
    <NavigationDrawer>
      <Chat />
    </NavigationDrawer>
  );
}

export default AdminCustomerSupport;
